import React from 'react';
import PropTypes from 'prop-types';
import CostObjLocation from './c/CostObjLocation';

const emptyLocation = {
  addressLine1: '',
  addressLine2: '',
  city: '',
  costObjectId: 0,
  country: '',
  id: 0,
  locationType: '',
  state: '',
  zipCode: ''
};

class ManageCostObjLocations extends React.Component {
  constructor(props) {
    super(props);
    this.props.costObjsActions.fetchLocationTypes();
    const [
      {
        addressLine1,
        addressLine2,
        city,
        costObjectId,
        country,
        locationId,
        locationType,
        state,
        zipCode
      }
    ] = props.locations;
    this.state = {
      isRemoveIconDisabled: true,
      costObjLocations: [
        {
          addressLine1,
          addressLine2,
          city,
          costObjectId,
          country,
          locationId,
          locationType,
          state,
          zipCode
        }
      ]
    };
  }

  handleLocationChange = (newLocation, index) => {
    const newLocations = this.state.costObjLocations.map(
      (location, newIndex) => {
        if (index !== newIndex) return { ...location };
        return { ...newLocation };
      }
    );
    this.setState({ costObjLocations: [...newLocations] });
    this.props.onLocationChange(newLocations);
  };

  handleAddLocation = () => {
    let costObjLocations;
    this.setState(
      oldState => {
        costObjLocations = [...oldState.costObjLocations];
        return {
          costObjLocations: []
        };
      },
      () => {
        this.setState(
          { costObjLocations: [...costObjLocations, emptyLocation] },
          () => {
            this.setState({
              isRemoveIconDisabled: this.state.costObjLocations.length <= 1
            });
            this.props.onLocationChange(this.state.costObjLocations);
          }
        );
      }
    );
  };

  handleRemoveLocation = index => {
    const newLocations = [...this.state.costObjLocations];
    newLocations.splice(index, 1);
    this.setState(
      {
        costObjLocations: []
      },
      () => {
        this.setState(
          {
            costObjLocations: [...newLocations]
          },
          () => {
            this.setState({
              isRemoveIconDisabled: this.state.costObjLocations.length <= 1
            });
            this.props.onLocationChange(this.state.costObjLocations);
          }
        );
      }
    );
  };

  render() {
    const { isRemoveIconDisabled, costObjLocations } = this.state;
    const { locationTypes, fetchingLocationTypes } = this.props;
    return (
      <div>
        {costObjLocations.map((location, index) => (
          <CostObjLocation
            key={ index }
            location={ location }
            isRemoveIconDisabled={ isRemoveIconDisabled }
            showAddIcon={ index + 1 === costObjLocations.length }
            locationTypes={ locationTypes }
            fetchingLocationTypes={ fetchingLocationTypes }
            onAddLocation={ this.handleAddLocation }
            onRemoveLocation={ () => this.handleRemoveLocation(index) }
            onLocationChange={ newLocation =>
              this.handleLocationChange(newLocation, index)
            }
          />
        ))}
      </div>
    );
  }
}

ManageCostObjLocations.propTypes = {
  fetchingLocationTypes: PropTypes.bool,
  onLocationChange: PropTypes.func.isRequired,
  locations: PropTypes.array.isRequired,
  locationTypes: PropTypes.array.isRequired,
  costObjsActions: PropTypes.shape({
    fetchLocationTypes: PropTypes.func.isRequired
  }).isRequired
};

ManageCostObjLocations.defaultProps = {
  fetchingLocationTypes: false
};

export default ManageCostObjLocations;



// WEBPACK FOOTER //
// ./src/components/manageCostObjs/comp/costObjEditor/ManageCostObjLocations.js